import React from "react";
import { Modal } from "../../../../shared/components/ui/Modal";
import { EditBuildingForm } from "../EditBuildingForm/EditBuildingForm";
import type { EditBuildingFormValues } from "../EditBuildingForm/EditBuildingForm";

interface EditBuildingModalProps {
  open: boolean;
  onClose: () => void;
  defaultValues: EditBuildingFormValues;
  onSubmit: (data: EditBuildingFormValues) => void;
  isSubmitting?: boolean;
  cityOptions: { value: string; label: string }[];
  statusOptions: { value: string; label: string }[];
}

export const EditBuildingModal: React.FC<EditBuildingModalProps> = ({
  open,
  onClose,
  defaultValues,
  onSubmit,
  isSubmitting,
  cityOptions,
  statusOptions,
}) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      title="Editar Unidad Residencial"
      // slightly wider modal for more natural form layout
      size="lg"
      className="p-6 sm:p-8"
    >
      <EditBuildingForm
        defaultValues={defaultValues}
        onSubmit={onSubmit}
        onCancel={onClose}
        isSubmitting={isSubmitting}
        cityOptions={cityOptions}
        statusOptions={statusOptions}
      />
    </Modal>
  );
};

// Re-export the form values type for convenience
export type { EditBuildingFormValues };

